
import { BarChart } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { motion } from 'framer-motion';
import { fadeIn, fadeInLeft } from '@/utils/animations';

interface MasterDashboardSectionProps {
  isInGrid?: boolean;
}

const MasterDashboardSection = ({ isInGrid = false }: MasterDashboardSectionProps) => {
  const isMobile = useIsMobile();
  
  if (isInGrid) {
    return (
      <motion.div 
        className="flex flex-col space-y-4"
        variants={fadeInLeft}
      >
        <div className="space-y-4">
          <div className="feature-icon bg-munger-blue/10 text-munger-blue inline-flex p-3 rounded-lg">
            <BarChart size={isMobile ? 24 : 28} />
          </div>
          <h3 className="text-2xl font-bold text-white">Master Dashboard</h3>
          <p className="text-munger-lightgray text-lg mb-6">
            Monitor results and manage campaigns manually if you desire.
          </p>
        </div>
      </motion.div>
    );
  }
  
  return (
    <section className="section bg-munger-darker py-16">
      <motion.div 
        className="max-w-6xl mx-auto px-6"
        variants={fadeIn}
      >
        <motion.div 
          className="flex flex-col space-y-4"
          variants={fadeInLeft}
        >
          <div className="space-y-4">
            <div className="feature-icon bg-munger-blue/10 text-munger-blue inline-flex p-3 rounded-lg">
              <BarChart size={isMobile ? 24 : 28} />
            </div>
            <h3 className="text-2xl font-bold text-white">Master Dashboard</h3>
            <p className="text-munger-lightgray text-lg mb-6">
              Monitor results and manage campaigns manually if you desire.
            </p>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default MasterDashboardSection;
